import { render } from "./button-bubble-tr.vue?vue&type=template&id=0f22dcfa&scoped=true"
const script = {}

import "./button-bubble-tr.vue?vue&type=style&index=0&id=0f22dcfa&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f22dcfa"],['__file',"src/views/other/cssfx/components/button-bubble-tr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f22dcfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f22dcfa', __exports__)) {
    console.log('reload')
    api.reload('0f22dcfa', __exports__)
  }
  
  module.hot.accept("./button-bubble-tr.vue?vue&type=template&id=0f22dcfa&scoped=true", () => {
    console.log('re-render')
    api.rerender('0f22dcfa', render)
  })

}


export default __exports__